import { useEffect, useState } from "react";
import TableComponent from "../../../../utilsComponent/TableComponent";
import { getClaimHistory } from "../ClaimForm/apiHelper";
import { COLUMN_TYPE } from "../../../../consts";
const ClaimHistory = ({policyId, setLoading, showLink=false, handleClick}) => {

  const columns = [
    { header: "Claim ID", accessor: "claimId", action: showLink ? "show_claim" : "", className: showLink ? "clickable-cell" : "" },
    { header: "Member Id", accessor: "memberId" },
    { header: "Patient Name", accessor: "patientName" },
    { header: "Reason of Hospitalization", accessor: "hospitalizeReason" },
    { header: "Date & Time of Admission", accessor: "admissionDate", type: COLUMN_TYPE.dateTime },
    { header: "Intimated Date & Time", accessor: "intimatedDate", type: COLUMN_TYPE.dateTime },
    { header: "Claim Amount", accessor: "totalClaimedAmount" },
    { header: "Sub Status", accessor: "substatus" },
    { header: "Status", accessor: "status" },
  ];

  const [claimHistory, setClaimHistory] = useState([])

  const fetchClaimHistory = async() => {
    const response = await getClaimHistory(policyId, setLoading)
    setClaimHistory(response)
  }
  useEffect(()=> {
    fetchClaimHistory();
  },[])

  return (
    <div className="m-4">
      <TableComponent columns={columns} data={claimHistory} title="Claim History" actionClick={handleClick} />
    </div>
  );
};

export default ClaimHistory;